<div>
  <app-nonbooking-payment [application]="status?.application"></app-nonbooking-payment>
  <div>
    <app-program-summary [program]="status?.application?.program" [user]="status?.application?.user" [application]="status?.application">
    </app-program-summary>
  </div>
</div>